/**
 * @flow
 * @relayHash 3f10cdf89a8f521496f3b35f44f018c7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PersonEditInput = {
  id: string,
  firstName: string,
  personType: string,
  lastName?: ?string,
  birthdayAt?: ?string,
  shortDescription?: ?string,
  description: string,
  descriptionHtml: string,
  smallAvatar?: ?string,
  verticalImage?: ?string,
  clientMutationId?: ?string,
};
export type PersonEditMutationVariables = {|
  input: PersonEditInput
|};
export type PersonEditMutationResponse = {|
  +PersonEdit: ?{|
    +person: ?{|
      +id: string
    |}
  |}
|};
export type PersonEditMutation = {|
  variables: PersonEditMutationVariables,
  response: PersonEditMutationResponse,
|};
*/


/*
mutation PersonEditMutation(
  $input: PersonEditInput!
) {
  PersonEdit(input: $input) {
    person {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PersonEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "PersonEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "PersonEditInput!"
      }
    ],
    "concreteType": "PersonEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "person",
        "storageKey": null,
        "args": null,
        "concreteType": "Person",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PersonEditMutation",
  "id": null,
  "text": "mutation PersonEditMutation(\n  $input: PersonEditInput!\n) {\n  PersonEdit(input: $input) {\n    person {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PersonEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "PersonEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd437414037e36edb82ef29ebadf09163';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/PersonEditMutation.graphql.js